import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M40 20a20 20 0 11-9.593-17.08l-1.324 2.174A17.456 17.456 0 1037.456 20H40z",
      fill: "#59779A"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M37.456 20a17.455 17.455 0 11-8.373-14.906l1.324-2.173A20 20 0 1040 20h-2.544z",
      fill: "#6B93C0"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      d: "M11.023 24.405a10 10 0 118.067 5.553l.241-2.637a7.352 7.352 0 10-5.93-4.083l-2.378 1.167z",
      fill: "#59779A"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.4 23.238a7.351 7.351 0 115.931 4.083l-.24 2.637a9.997 9.997 0 0010.313-6.557 10 10 0 10-18.381 1.004l2.377-1.167z",
      fill: "#6B93C0"
    }, null, -1 /* HOISTED */)
  ])))
}